module.exports = __webpack_public_path__ + "img/zzipco.a6ad4373.png";